export {default as randomUniform} from "./src/uniform";
export {default as randomNormal} from "./src/normal";
export {default as randomLogNormal} from "./src/logNormal";
export {default as randomBates} from "./src/bates";
export {default as randomIrwinHall} from "./src/irwinHall";
export {default as randomExponential} from "./src/exponential";



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-random/index.js
// module id = ../../../../d3-random/index.js
// module chunks = 4